import {
  Button,
  TextField,
  DialogActions,
  DialogTitle,
  IconButton,
  InputAdornment,
} from "@mui/material";
import React, { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { updateAdminUser } from "service/users/AdminUsers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShowFullScreenBackdrop from "components/ShowFullScreenBackdrop";

const AdminChangePassword = ({ handleClose, newPasswordId }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const handleToggleShowPassword = (type) => {
    switch (type) {
      case "new":
        setShowNewPassword((prev) => !prev);
        break;
      case "confirm":
        setShowConfirmPassword((prev) => !prev);
        break;
      default:
        break;
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const newPasswordData = {
      password: newPassword,
    };

    try {
      setOpen(true);

      const response = await updateAdminUser(newPasswordData, newPasswordId);

      if (response.status === 200) {
        handleClose();
        toast.success("New password successfully!");
        setOpen(false);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Password update failed. Please try again.");
      }
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <DialogTitle sx={{ fontSize: "18px", fontWeight: "600" }}>
        UPDATE PASSWORD
      </DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            padding: "1rem",
          }}
        >
          <TextField
            fullWidth
            margin="normal"
            label="New Password"
            color="secondary"
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleToggleShowPassword("new")}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ margin: "1rem", width: "calc(100% - 1rem)" }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Confirm New Password"
            color="secondary"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleToggleShowPassword("confirm")}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ margin: "1rem", width: "calc(100% - 1rem)" }}
          />
        </div>
        <DialogActions>
          <Button
            variant="contained"
            sx={{ margin: "1em" }}
            color="error"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="info"
            sx={{ margin: "1rem" }}
          >
            Update Password
          </Button>
        </DialogActions>
      </form>
      {open && <ShowFullScreenBackdrop open={open} />}
    </>
  );
};

export default AdminChangePassword;
